import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'
import {
  updateToken
} from '@js/url.js';
import {
  httpCountObj
} from '@loading';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

//  志愿者

const baseURL = '';
let http = axios.create({
  headers: {
    // 默认值 ,另一种是
    // "content-type": "application/x-www-form-urlencoded",
    'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    // 'Content-Type': 'application/json',
  },
  baseURL,
  timeout: 30000,

  // `params` 是即将与请求一起发送的 URL 参数
  // 必须是一个无格式对象(plain object)或 URLSearchParams 对象
  params: {
    
  }

  // `hpp
})

// 请求前
http.interceptors.request.use(config => {
  let {
    loading = true
  } = config;
  if(loading){
    httpCountObj.add();
    httpCountObj.showLoading();
  }
  if (config.method === 'post') {
      config.data = qs.stringify(config.data);
  }
  var token = sessionStorage.getItem("volunteer-token") || '';
  if (token) {
    config.headers.common['access_token'] = token;
  }
  return config
})

// 请求后
http.interceptors.response.use(
  res => {

    updateToken(res);
    let {
      loading = true
    } = res.config
    if(loading){
      httpCountObj.reduce()
    }

    const { status } = res;
    if (status === 200) {
      httpCountObj.checkCountIsZero()
      let { data } = res
      let { 
          State = false , 
          status = false, 
          success = false,
          Msg ,
          msg,
      } = data;
      if (State || success || status) {
        return Promise.resolve({ data })
      } else {
        // setTimeout(() => {
          Toast.fail(Msg || msg);
        // }, 150);
        console.log(Msg || msg);
        return Promise.reject({ data })
      }
    }
    throw Error('网络错误')
  },
  err => {
    Toast.fail('数据获取失败')
    httpCountObj.clear()
  }
)

export default {
  // get请求是用来获取数据的，只是用来查询数据，不对服务器的数据做任何的修改
  get: (url, params = {}, config) => {
    return http.get(url, params, config)
  },

  // post请求一般是对服务器的数据做改变，常用来数据的提交，新增操作
  post: (url, params = {}, config = {}) => {
    return http.post(url, params, config)
  },

  // put请求与post一样都会改变服务器的数据，但是put的侧重点在于对于数据的修改操作，但是post侧重于对于数据的增加。
  put: (url, params = {}, config) => {
    return http.put(url, params, config)
  },

  // delete请求用来删除服务器的资源
  delete: (url, params = {}, config) => {
    return http.delete(url, params, config)
  }
}
